import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { StepperService } from '../../services/stepper-service/stepper.service'
import { LoaderService } from '../../services/loader-service/loader.service'
import { sendGtagEvent } from '../../utils/functions/analytic-event'
import { EVENT_NAMES } from '../../utils/events'
@Component({
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  styleUrls: ['./redirect-page.component.scss'],
})
export class RedirectPageComponent implements OnInit {
  isCrm = false
  productFlow: string = ''
  process: string = ''

  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(
    private router: Router,
    private stepperService: StepperService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    const loginConfig = this.storage.get(EVENT_NAMES.loginConfig)
    const flow = loginConfig && loginConfig.flow ? loginConfig.flow : 'transaccional'
    const process = loginConfig && loginConfig.process ? loginConfig.process : 'autogestion'
    this.productFlow = flow
    this.process = process
    this.isCrm = loginConfig?.process === 'asistido'

    setTimeout(() => {
      this.loaderService.updateLoader(false)
    }, 500)
    this.storage.clear()
    this.stepperService.setProspectSteps('')
  }

  public handleRedirect = async () => {
    await this.router.navigate(['transaccional', 'autogestion'], { replaceUrl: true })
    sendGtagEvent('click_button', { category: 'redirect_transactional' })
    location.reload()
  }
}
